<template>
  <div v-if="isVisible" :class="['container', expansionState]">
    <div class="container-header" @click="toggleExpansion">
      <span>{{ pmAkademiTitle }}</span>
    </div>
    <div class="container-content">
      <router-link :to="pmAkademiRoute">
        <img :src="widgetBannerSrc" alt="PM Akademi" class="widget-banner-image" />
      </router-link>
    </div>
  </div>
</template>
<script>
import gtmUtils from '@/mixins/gtmUtils.js';
import { PM_AKADEMI, PM_AKADEMI_ASSETS } from '@/constants/urls.constants';
import StorageHelper from '@/utils/storageHelper';

export default {
  name: 'PmAkademiCard',
  mixins: [gtmUtils],
  LEARNING_MENU_NAME: 'Öğren',
  data() {
    return {
      expansionStatus: {
        isExpanded: false,
        hasBeenExpanded: false,
      },
    };
  },
  computed: {
    pmAkademiTitle() {
      return PM_AKADEMI.DEFAULT_TITLE;
    },
    expansionState() {
      return this.expansionStatus.isExpanded ? 'shown' : 'collapsed';
    },
    widgetBannerSrc() {
      return PM_AKADEMI_ASSETS.WIDGET_BANNER;
    },
    pmAkademiRoute() {
      return PM_AKADEMI.getRoute();
    },
    isVisible() {
      const storage = new StorageHelper({
        id: process.env.VUE_APP_STORAGE_MENU_ITEMS,
      });
      const storedData = storage.get();

      if (!this.isValidMenuData(storedData)) {
        return false;
      }

      return this.isPmAkademiMenuVisible(storedData.menuItems);
    },
  },
  methods: {
    isValidMenuData(storedData) {
      return storedData?.menuItems && Array.isArray(storedData.menuItems);
    },
    isPmAkademiMenuVisible(menuItems) {
      const learningMenu = menuItems.find(item => item.name === this.$options.LEARNING_MENU_NAME);
      if (!learningMenu?.children) {
        return false;
      }

      return learningMenu.children.some(item => item.name === PM_AKADEMI.DEFAULT_TITLE);
    },
    toggleExpansion() {
      this.expansionStatus.isExpanded = !this.expansionStatus.isExpanded;

      if (this.expansionStatus.isExpanded && !this.expansionStatus.hasBeenExpanded) {
        this.pushDataLayerEvent('pm_akademi_card');
        this.expansionStatus.hasBeenExpanded = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  height: 206px;
  padding: 0px 16px;
  overflow: hidden;
  color: #fff;
  background: #0042a6;
  transition: height 0.5s ease-out;
  &.collapsed {
    height: 50px;
    background: #0042a6;
  }
  &.shown {
    height: 206px;
    background: #0042a6;
  }
  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    font-weight: bold;
    cursor: pointer;
  }
  &-content {
    height: calc(100% - 50px);
    padding-top: 8px;
    padding-bottom: 16px;
    display: flex;
    justify-content: center;
    align-items: center;

    a {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
    }

    .widget-banner-image {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }
}
</style>
